<div id="error-container" class="error-container" [class.invisible]="!control.touched || !error">
  <div class="error-message">
    {{ error }}
  </div>
</div>
